import React from 'react';
import { motion } from 'framer-motion';
import { Logo } from './Logo';
export function ThankYouScreen() {
  return <motion.div initial={{
    opacity: 0,
    y: 16
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    ease: [0.22, 1, 0.36, 1]
  }} className="relative min-h-screen w-full flex items-center justify-center px-5 sm:px-6 py-12 overflow-hidden" data-id="element-45">
      <div aria-hidden className="pointer-events-none absolute inset-0 -z-10" style={{
      background: 'radial-gradient(circle at 50% 35%, rgba(255,255,255,0.08), transparent 55%)'
    }} data-id="element-46" />

      <div className="max-w-2xl text-center relative" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        scale: 0.85
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.1,
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} className="flex justify-center mb-6 sm:mb-8" data-id="element-48">
          <Logo className="w-16 h-16 sm:w-20 sm:h-20" data-id="element-49" />
        </motion.div>

        <p className="text-xs sm:text-sm uppercase tracking-[0.2em] text-neutral-500 mb-3 sm:mb-4" data-id="element-50">
          Application received
        </p>

        <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold tracking-tight leading-[1.1] text-white" data-id="element-51">
          Thanks for applying
        </h1>

        <p className="mt-5 sm:mt-6 text-sm sm:text-lg md:text-xl text-neutral-400 leading-relaxed max-w-xl mx-auto" data-id="element-52">
          We review every application personally. You can expect to hear from
          the Magic Patterns team within a couple of weeks.
        </p>

        <div className="mt-10 sm:mt-12 flex flex-col items-center gap-4" data-id="element-53">
          <a href="https://www.magicpatterns.com" className="inline-flex items-center gap-2 bg-white text-black font-semibold text-base sm:text-lg px-7 sm:px-8 py-3 rounded-md hover:bg-neutral-200 transition-colors" data-id="element-54">
            Back to Magic Patterns
          </a>
          <p className="text-neutral-500 text-xs sm:text-sm" data-id="element-55">
            In the meantime, follow{' '}
            <a href="https://twitter.com/magicpatterns" className="text-neutral-300 underline-offset-4 hover:underline hover:text-white transition-colors" data-id="element-56">
              @magicpatterns
            </a>{' '}
            for updates.
          </p>
        </div>
      </div>
    </motion.div>;
}